import { render, staticRenderFns } from "./DlgLivePlayer.vue?vue&type=template&id=73a6a04f&scoped=true&"
import script from "./DlgLivePlayer.vue?vue&type=script&lang=js&"
export * from "./DlgLivePlayer.vue?vue&type=script&lang=js&"
import style0 from "./DlgLivePlayer.vue?vue&type=style&index=0&id=73a6a04f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a6a04f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
